var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lfs-shard-list"},[_c('lfs-toolbar'),_c('div',{staticClass:"wrap-content",attrs:{"app":""}},[_c('v-row',[_c('v-col',{staticStyle:{"padding-bottom":"0"}},[_c('CurrentShardList')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }